import { useTranslation } from "react-i18next";
import { selectLoading } from "../../../../Database/redux/selectors";
import { CreateEntityModal } from "../../../../Modals/CreateEntityModal";
import { useAppDispatch } from "../../../../../services/redux/hooks/use-dispatch";
import { useAppSelector } from "../../../../../services/redux/hooks/use-selector";
import {
  TStore,
  TStoreData,
} from "../../../../../services/api/instances/vectorStoreApi/types";
import { TEntityInfo } from "../../../../../common/types/utility";
import { createStoreAction } from "../../../../Database/redux/actions/openai_store_actions";
import { GenericSelect } from "../../../../../shared/components/AppGenericSelect";
import { useState } from "react";
import { createLocalStoreAction } from "../../../../Database/redux/actions/local_store_actions";
import { APP_VECTOR_STORE_MODE } from "../../../../../services/api/constants";
import { TModalsIds } from "../../../../../app/state/modalSlice/types";
import { useModalSelectors } from "../../../../../app/state/modalSlice/hook/use-modal-selectors";

interface Props {
  closeModal: (id: TModalsIds) => void;
  callFileModal: (id: TModalsIds, info: TEntityInfo | null) => void;
  onStoreCreated?: (store: TStoreData) => void;
}

type TSelectStore = {
  id: TStore;
  name: string;
};

const SELECT_STORES_TYPE: TSelectStore[] = [
  {
    id: "openai",
    name: "База знаний в OpenAI",
  },
  {
    id: "local",
    name: "Локальная база",
  },
];

export const CreateStoreModal = (props: Props) => {
  const dispatch = useAppDispatch();
  const isLoading = useAppSelector(selectLoading);
  const createStoreModal = useModalSelectors("create_store_modal");
  const [storeType, setStoreType] = useState<TSelectStore | null>(null);
  const [isDisabled, setIsDisabled] = useState<boolean>(true);
  const { t } = useTranslation();

  const handleCreateStore = (name: string) => {
    if (storeType?.id === "openai" || APP_VECTOR_STORE_MODE === "openai") {
      dispatch(createStoreAction(name))
        .unwrap()
        .then((createdStore) => {
          if (!createdStore) return;
          props.onStoreCreated?.(createdStore);
          props.closeModal("create_store_modal");
          props.callFileModal("add_file_to_database", {
            id: createdStore.id,
            value: createdStore.name,
          });
        });
    } else if (storeType?.id === "local" || APP_VECTOR_STORE_MODE === "local") {
      dispatch(createLocalStoreAction(name))
        .unwrap()
        .then((createdStore) => {
          if (!createdStore) return;
          props.onStoreCreated?.(createdStore);
          props.closeModal("create_store_modal");
          props.callFileModal("add_file_to_database", {
            id: createdStore.id,
            value: createdStore.name,
          });
        });
    }
  };

  const onSelectStoreType = (type: TSelectStore | null) => {
    setStoreType(type);
    type !== null ? setIsDisabled(false) : setIsDisabled(true);
  };

  return (
    <CreateEntityModal
      title={t("knowledge_base.modal_create_store")}
      isOpen={createStoreModal.isOpen}
      createEntity={handleCreateStore}
      closeModal={() => props.closeModal("create_store_modal")}
      placeholder={t("knowledge_base.modal_create_store_placeholder")}
      isInputDisabled={APP_VECTOR_STORE_MODE === "both" && isDisabled}
      extraElement={
        APP_VECTOR_STORE_MODE === "both" && (
          <GenericSelect<TSelectStore>
            options={SELECT_STORES_TYPE}
            value={storeType}
            onChange={onSelectStoreType}
            getLabel={(store) => store.name ?? ""}
            getValue={(store) => store.id}
            placeholder={"Выберите тип Базы знаний"}
          />
        )
      }
      isLoading={isLoading}
    />
  );
};
